import { requestApi } from '../util/network'


export const vact_specify =
    (id,token) =>
      requestApi(
        '/Activity/vact_specify',
        'POST',
        {
          vid: id,
          key: token
        }
      )
// 立即领取
export const vact_specify_receive =
(id,token) =>
requestApi(
    '/Activity/vact_specify_receive',
    'POST',
    {
    vid: id,
    key: token
    }
)    
      